<template>
  <div class="page-not-found--wrap">
    <div class="layout-box">
      <h1 class="logo" slot="extra">
        <router-link :to="{ name: 'home' }">
          <i class="icon icon--logo-new"></i>
        </router-link>
      </h1>
      <content-box class="" :width="'480px'" :height="'389px'">
        <i class="icon" :class="`icon--404-${currentLang}`"></i>
        <p class="desc">{{ $t('common.pageNotFound') }}</p>
        <ui-button primary3 class="button__prev" @click="goToPrev">
          <i class="icon icon--prev-gray-size16"></i>
        </ui-button>
      </content-box>
    </div>
  </div>
</template>

<script>
import ContentBox from '@/components/ui/ContentBox'
import UiButton from '@/components/ui/UiButton'

export default {
  components: {
    ContentBox,
    UiButton
  },
  computed: {
    currentLang () {
      if (this.$i18n.locale === 'ja') {
        return 'ja'
      } else {
        return 'default'
      }
    }
  },
  methods: {
    goToPrev () {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
.page-not-found--wrap {
  .layout-box {
    @include positionXYcenter;

    .logo {
      margin-left: 15px;
      margin-bottom: 15px;

      a {
        display: inline-block;
      }
    }
  }
  .content--wrap {
    padding-top: 80px;
    text-align: center;

    .desc {
      font-size: 16px;
      font-weight: bold;
      color: #666666;
      margin-top: 10px;
    }

    .button__prev {
      position: relative;
      margin-top: 28px;
      display: inline-block;
      width: 38px;
      height: 38px;
      border-radius: 20px;
      border: solid 1px #bbbbbb;
      background-color: #ffffff;
      min-width: 0;
      padding: 0;

      /deep/ .text {
        display: inline-block;
        width: 100%;
        height: 100%;
        position: initial;

        .icon {
          @include positionXYcenter;
        }
      }
    }
  }
}
</style>
